var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var AppSessionService = /** @class */ (function () {
    function AppSessionService(_sessionService, _abpMultiTenancyService) {
        this._sessionService = _sessionService;
        this._abpMultiTenancyService = _abpMultiTenancyService;
        this.sessionInfo = {};
    }
    Object.defineProperty(AppSessionService.prototype, "application", {
        get: function () {
            return this._application;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "user", {
        get: function () {
            return this._user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "friendshipLink", {
        get: function () {
            return this._friendshipLink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "userId", {
        get: function () {
            return this.user ? this.user.id : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "tenant", {
        get: function () {
            return this._tenant;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "tenancyName", {
        get: function () {
            return this._tenant ? this.tenant.tenancyName : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "tenantId", {
        get: function () {
            return this.tenant ? this.tenant.id : null;
        },
        enumerable: true,
        configurable: true
    });
    AppSessionService.prototype.getShownLoginName = function () {
        var userName = this._user.userName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return userName;
        }
        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    };
    Object.defineProperty(AppSessionService.prototype, "fBoxAlias", {
        get: function () {
            if (!this._fBoxAlias) {
                this.getLocalStorageSession();
            }
            return this._fBoxAlias;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "flexAlias", {
        get: function () {
            if (!this._flexAlias) {
                this.getLocalStorageSession();
            }
            return this._flexAlias;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSessionService.prototype, "isSupportAdvancedCommunication", {
        get: function () {
            if (!this._isSupportAdvancedCommunication) {
                this.getLocalStorageSession();
            }
            return this._isSupportAdvancedCommunication;
        },
        enumerable: true,
        configurable: true
    });
    AppSessionService.prototype.getLocalStorageSession = function () {
        var sessionInfo = JSON.parse(localStorage.getItem('sessionInfo'));
        if (sessionInfo) {
            this.sessionInfo = sessionInfo;
            this._isSupportAdvancedCommunication = this.sessionInfo.isSupportAdvancedCommunication;
            this._flexAlias = this.sessionInfo.flexAlias;
            this._fBoxAlias = this.sessionInfo.fBoxAlias;
        }
    };
    AppSessionService.prototype.init = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._sessionService.getCurrentLoginInformations().toPromise().then(function (result) {
                _this._application = result.application;
                _this._user = result.user;
                _this._tenant = result.tenant;
                _this._friendshipLink = result.friendshipLink;
                _this._fBoxAlias = result.fBoxAlias;
                _this._flexAlias = result.flexAlias;
                _this._isSupportAdvancedCommunication = result.isSupportAdvancedCommunication;
                resolve(true);
            }, function (err) {
                reject(err);
            });
        });
    };
    AppSessionService.prototype.changeTenantIfNeeded = function (tenantId) {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }
        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    };
    AppSessionService.prototype.isCurrentTenant = function (tenantId) {
        if (!tenantId && this.tenant) {
            return false;
        }
        else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }
        return true;
    };
    AppSessionService = __decorate([
        Injectable()
    ], AppSessionService);
    return AppSessionService;
}());
export { AppSessionService };
